// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610120648/js/" + chunkId + "." + {"44":"dfeadce8","225":"82d98d05","481":"23322bdf","486":"50809119","770":"cd99a565"}[chunkId] + ".0.5337730629422731.chunk.js";
};